import insta from './Recursos/insta.svg'
import tiktok from './Recursos/tiktok.svg'
import instacafe from './Recursos/instacafe.svg'
import tiktokcafe from './Recursos/tiktokcaef.svg'

export const SECCIONES = ['CATEGORÍAS', 'COLECCIONES']

export const NEGRITA = 'Dm Serif Display'

export const NUMWASS = 573224510644

export const VALORENVIOGRATIS = 400000

export const REDESCLARAS = [
    {
        icono: insta,
        iconocafe: instacafe,
        nombre: 'Instagram',
        url: 'https://www.instagram.com/amevi.co/'
    },
    /*  {
          icono: face,
          nombre: 'Facebook',
          url: 'https://www.facebook.com/profile.php?id=61572691807949'
      },*/
    {
        icono: tiktok,
        iconocafe: tiktokcafe,
        nombre: 'Facebook',
        url: 'https://www.tiktok.com/@amevi.co'
    },
]


export const CATEGORIAS = [
    {
        nombre: 'Accesorios',
        color: '#796254'
    },
    {
        nombre: 'Superior',
        color: '#796254'
    },
    {
        nombre: 'Inferior',
        color: '#808080'
    },
]
